export const mutations = {
  setThirdPartyPayment(state, thirdPartyPayments) {
    state.thirdPartyPayments = thirdPartyPayments;
  },
  setLoading(state, loading){
    state.isLoading = loading;
  },
};
